/**
 * Texto útil para exibir como "localização" no histórico.
 * Ignora placeholders (0,0), endereços vazios/só pontuação e coordenadas inválidas.
 */
function isTrivialOrPlaceholderText(s) {
  const t = String(s).trim();
  if (!t) return true;
  if (/^0\s*,\s*0$/i.test(t)) return true;
  // Vírgula ou só separadores (dados corrompidos / API)
  if (/^[,;\s:.-]+$/u.test(t)) return true;
  return false;
}

function pickFiniteCoord(v) {
  if (v == null) return null;
  if (typeof v === "string" && !String(v).trim()) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function locationTextForDisplay(loc) {
  if (loc == null) return null;
  if (typeof loc === "string") {
    const t = String(loc).trim();
    if (isTrivialOrPlaceholderText(t)) return null;
    return t;
  }
  if (typeof loc !== "object") return null;

  const addrRaw = loc.address != null ? String(loc.address) : "";
  if (!isTrivialOrPlaceholderText(addrRaw)) {
    return String(addrRaw).trim();
  }
  const nameRaw = loc.name != null ? String(loc.name) : "";
  if (!isTrivialOrPlaceholderText(nameRaw)) {
    return String(nameRaw).trim();
  }

  const lat =
    loc.latitude != null ? loc.latitude : loc.lat != null ? loc.lat : null;
  const lng =
    loc.longitude != null ? loc.longitude : loc.lng != null ? loc.lng : null;
  const latN = pickFiniteCoord(lat);
  const lngN = pickFiniteCoord(lng);
  if (latN == null || lngN == null) return null;
  if (latN === 0 && lngN === 0) return null;
  return `${latN}, ${lngN}`;
}

export function isPlaceholderLatLng(lat, lng) {
  const latN = pickFiniteCoord(lat);
  const lngN = pickFiniteCoord(lng);
  if (latN == null || lngN == null) return false;
  return latN === 0 && lngN === 0;
}

function formatCoordsLine(loc) {
  if (loc == null || typeof loc !== "object") return null;
  const lat =
    loc.latitude != null ? loc.latitude : loc.lat != null ? loc.lat : null;
  const lng =
    loc.longitude != null ? loc.longitude : loc.lng != null ? loc.lng : null;
  const latN = pickFiniteCoord(lat);
  const lngN = pickFiniteCoord(lng);
  if (latN == null || lngN == null) return null;
  if (latN === 0 && lngN === 0) return null;
  return `${latN}, ${lngN}`;
}

/** Coordenadas finitas e não placeholder para mapa / link. */
export function locationCoordsForDisplay(loc) {
  if (loc == null || typeof loc !== "object") return null;
  const lat =
    loc.latitude != null ? loc.latitude : loc.lat != null ? loc.lat : null;
  const lng =
    loc.longitude != null ? loc.longitude : loc.lng != null ? loc.lng : null;
  const latN = pickFiniteCoord(lat);
  const lngN = pickFiniteCoord(lng);
  if (latN == null || lngN == null) return null;
  if (latN === 0 && lngN === 0) return null;
  return { lat: latN, lng: lngN };
}

/**
 * Título e subtítulo para cartão estilo WhatsApp (nome, endereço, coordenadas).
 * @returns {{ primary: string|null, secondary: string|null }}
 */
export function locationCardLines(loc) {
  if (loc == null) return { primary: null, secondary: null };
  if (typeof loc === "string") {
    const t = String(loc).trim();
    if (isTrivialOrPlaceholderText(t)) return { primary: null, secondary: null };
    return { primary: t, secondary: null };
  }
  if (typeof loc !== "object") return { primary: null, secondary: null };

  const nameRaw = loc.name != null ? String(loc.name) : "";
  const addrRaw = loc.address != null ? String(loc.address) : "";
  const nameOk = !isTrivialOrPlaceholderText(nameRaw) ? String(nameRaw).trim() : null;
  const addrOk = !isTrivialOrPlaceholderText(addrRaw) ? String(addrRaw).trim() : null;
  const coords = formatCoordsLine(loc);

  if (nameOk && addrOk) {
    return { primary: nameOk, secondary: addrOk };
  }
  if (addrOk) {
    return { primary: addrOk, secondary: coords && addrOk !== coords ? coords : null };
  }
  if (nameOk) {
    return { primary: nameOk, secondary: coords && nameOk !== coords ? coords : null };
  }
  if (coords) {
    return { primary: coords, secondary: null };
  }
  return { primary: null, secondary: null };
}
